<div class="container">
  <!-- Header usando componente shared -->
  <app-page-header
    title="Generar Certificados"
    subtitle="Genera certificados para clientes y proveedores"
    icon="certificate">
  </app-page-header>

  <div class="form-alert form-alert--error" *ngIf="showAlertError">
    <i class="form-alert-icon">⚠</i>
    <span>{{ errorMessage }}</span>
  </div>
  <div class="form-alert form-alert--success" *ngIf="showAlertSuccess">
    <i class="form-alert-icon">✓</i>
    <span>{{ successMessage }}</span>
  </div>
  <section class="certificados-section">
    <div class="form-container">
      <form class="form-wrapper" #certificadoForm="ngForm" (ngSubmit)="onSubmit(certificadoForm)">
        <div class="form-content">
          <div class="form-row">
            <div class="form-group">
              <label for="tipoCertificado" class="form-label form-label--required">Tipo de Certificado</label>
              <select 
                class="form-input form-select" 
                [ngClass]="{'form-input--error': tipoCertificadoModel.invalid && tipoCertificadoModel.touched}"
                id="tipoCertificado"
                [(ngModel)]="formData.tipoCertificado" 
                name="tipoCertificado" 
                #tipoCertificadoModel="ngModel" 
                required>
                <option value="" disabled selected>Selecciona el tipo de certificado</option>
                <option *ngFor="let tipo of tiposCertificado" [value]="tipo.value">
                  {{ tipo.label }}
                </option>
              </select>
              <div *ngIf="tipoCertificadoModel.invalid && tipoCertificadoModel.touched" class="form-error-message">
                <i class="form-error-icon">⚠</i>
                <span class="form-error-text">Este campo es requerido</span>
              </div>
            </div>

            <div class="form-group">
              <label for="documentId" class="form-label form-label--required">Número de Documento</label>
              <input 
                type="text" 
                class="form-input" 
                [ngClass]="{'form-input--error': documentIdModel.invalid && documentIdModel.touched}"
                placeholder="Ingresa el número de documento" 
                id="documentId"
                [(ngModel)]="formData.documentId" 
                name="documentId" 
                #documentIdModel="ngModel" 
                required
                maxlength="20">
              <div *ngIf="documentIdModel.invalid && documentIdModel.touched" class="form-error-message">
                <i class="form-error-icon">⚠</i>
                <span class="form-error-text">Este campo es requerido</span>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group" *ngIf="formData.tipoCertificado === 'ingresos' || formData.tipoCertificado === 'costos-totales'">
              <label for="email" class="form-label form-label">Correo Electrónico (correo donde se enviará el certificado generado)</label>
              <input 
                type="email" 
                class="form-input" 
                [ngClass]="{'form-input--error': emailModel.invalid && emailModel.touched}"
                placeholder="ejemplo@correo.com" 
                id="email"
                [(ngModel)]="formData.email" 
                name="email" 
                #emailModel="ngModel" >
              <div *ngIf="emailModel.invalid && emailModel.touched" class="form-error-message">
                <i class="form-error-icon">⚠</i>
                <span class="form-error-text" *ngIf="emailModel.errors?.['email']">Ingresa un correo válido</span>
              </div>
            </div>

            <div class="form-group">
              <label for="year" class="form-label form-label--required">Año</label>
              <select 
                class="form-input form-select" 
                [ngClass]="{'form-input--error': yearModel.invalid && yearModel.touched}"
                id="year"
                [(ngModel)]="formData.year" 
                name="year" 
                #yearModel="ngModel" 
                required>
                <option value="" disabled selected>Selecciona un año</option>
                <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
              </select>
              <div *ngIf="yearModel.invalid && yearModel.touched" class="form-error-message">
                <i class="form-error-icon">⚠</i>
                <span class="form-error-text">Este campo es requerido</span>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button 
            type="button" 
            class="form-btn form-btn--cancel" 
            [ngClass]="{'is-active': certificadoForm.valid}"
            (click)="cancel(certificadoForm)"
            [disabled]="isLoading">Limpiar</button>
          <button 
            type="submit" 
            class="form-btn form-btn--submit" 
            [ngClass]="{'is-valid': certificadoForm.valid && !isLoading, 'is-loading': isLoading}"
            [disabled]="certificadoForm.invalid || isLoading">
            <span *ngIf="!isLoading">Generar Certificado</span>
            <span *ngIf="isLoading" class="form-spinner"></span>
          </button>
        </div>
      </form>
    </div>
  </section>
</div>

<!-- Modal de descarga -->
<app-download-modal
  [isOpen]="showDownloadModal"
  [title]="'Certificado Listo'"
  [message]="formData.tipoCertificado === 'ingresos' ? 'El certificado ha sido generado exitosamente y está listo para descargar.' : 'El certificado ha sido generado exitosamente y se abrirá en una nueva pestaña.'"
  [fileName]="downloadFileName"
  (onClose)="closeDownloadModal()"
  (onDownload)="handleDownload()">
</app-download-modal>